/**
 * Every URL, contact and id the site links to, in one place. Navbar, Footer,
 * every CTA and the prerender check read from here, so a changed address is a
 * one-line edit rather than a grep.
 */

/** The product site. Every primary CTA goes here — a visitor should see the
 *  product before being asked to book anything (owner decision, 2026-10-03). */
export const PREMIZE_URL = 'https://premize.agicafet.com';

/** Where a PreMize link was clicked, carried as `utm_content` so the PreMize
 *  site can tell which part of this page sends people. No cookie involved. */
export type Placement = 'nav' | 'hero' | 'premize' | 'contact';

export function premizeHref(placement: Placement): string {
  const q = new URLSearchParams({
    utm_source: 'agicafet.com',
    utm_medium: 'referral',
    utm_content: placement,
  });
  return `${PREMIZE_URL}/?${q.toString()}`;
}

export const EMAIL = 'natdhanai.pra@agicafet.com';
export const PHONE_TEL = 'tel:+66945492624';
export const PHONE_DISPLAY = '+66 94 549 2624';
export const FACEBOOK_URL = 'https://www.facebook.com/profile.php?id=100063640873544';
/** Set when a LINE Official Account exists; the contact section shows it then. */
export const LINE_OA_URL: string | null = null;

export function mailto(subject: string): string {
  return `mailto:${EMAIL}?subject=${encodeURIComponent(subject)}`;
}

export const FOUNDER = {
  name: 'Natdhanai Praneenatthavee',
  nickname: 'Job',
  role: 'Founder & CEO',
} as const;

/** Section ids in page order. `scripts/prerender.cjs` keeps a literal copy of
 *  this list (a .cjs file cannot import TS) — change both together. */
export const SECTION_IDS = ['top', 'what', 'how', 'stacks', 'premize', 'training', 'proof', 'team', 'community', 'faq', 'contact'] as const;
export type SectionId = (typeof SECTION_IDS)[number];

/** The five navbar links. */
export const NAV: ReadonlyArray<{ id: SectionId; label: string }> = [
  { id: 'what', label: 'What we do' },
  { id: 'how', label: 'How it works' },
  { id: 'stacks', label: 'Qwen & NVIDIA' },
  { id: 'premize', label: 'PreMize' },
  { id: 'contact', label: 'Contact' },
];
